import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  @Input() message: string | undefined;
  @Output() close = new EventEmitter<void>();
  safeMessage!: SafeHtml;  
  constructor(private auth: AuthenticationService,private sanitizer: DomSanitizer) {
    this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
    this.message = this.safeMessage as string as any;  // bind sanitized HTML
  }

  ngOnInit(): void {}

  onClose() {
    this.close.emit();
  }
}
